import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ViewUIPlus from "view-ui-plus";
import "view-ui-plus/dist/styles/viewuiplus.css";
import "./main.css";
import print from "vue3-print-nb";
// 引入elm的plus
// 导入element-plus
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as echarts from "echarts";

// 引入axios
import axios from "axios";
import VueAxios from "vue-axios";
//引入封装Axios请求
import Axios from "./request/axios.js";
import citys from "@/utils/citys.js";
import Public from "@/utils/public.js";
import Print from "@/utils/print";

createApp(App)
  .use(VueAxios, axios)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(ViewUIPlus)
  .use(Axios)
  .use(citys)
  .use(Public)
  .use(print)
  .use(Print)
  .mount("#app");
